import { uri } from '../../api-endpoint';
import { IProjectFromAPISuccessResponse } from '../../type-conversion/project/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchProjectListAPI = (token: string) => (companyId: number) =>
  fetchListTemplateFn(
    token,
    uri.projectListOfCompany(companyId),
    IProjectFromAPISuccessResponse
  );
